import bugsnag from 'bugsnag-js';
import React from 'react';
import ReactDOM from 'react-dom';
import createPlugin from 'bugsnag-react';
import { BrowserRouter, Route } from 'react-router-dom';
import { LastLocationProvider } from 'react-router-last-location';
import Tracker from 'libs/Tracker';
import ScrollToTop from 'libs/ScrollToTop';
import App from './App';

const bugsnagClient = bugsnag('3f16628333c726873840b15a27fb77bc');
const ErrorBoundary = bugsnagClient.use(createPlugin(React));

ReactDOM.render(
  <ErrorBoundary>
    <BrowserRouter
      forceRefresh={false}
    >
      <LastLocationProvider>
        <ScrollToTop>
          <Route component={Tracker(App)} />
        </ScrollToTop>
      </LastLocationProvider>
    </BrowserRouter>
  </ErrorBoundary>,
  document.querySelector('.root'),
);



// WEBPACK FOOTER //
// ./src/index.jsx